import axios from "axios";
import GlobalURL from "../baseUrl";

export function performVerification() {
  if (localStorage.getItem("token")) {
    return true;
  } else return false;
}


export async function tokenVerification(token) {
  const Locallang = localStorage.getItem('lang');
  try {
    const response = await axios.post(
      `${GlobalURL}/api/dev/admin/getRefreshToken`,
      {
        id: localStorage.getItem("admin_id"),
      },
      {
        headers: {
          "Content-Type": "application/json",
          lang_id: Locallang,
          token: token,
        },
      }
    );
    const data = response.data;
    
    if (data.message === "Invalid token") {
      return "relogin";
    }
    if (data.status_code === 200) {
      return data.data[0].token;
    }
  } catch (error) {
    console.error("Error fetching refresh token:", error);
  }
}
